import React from "react";
import { Helmet } from "react-helmet-async";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Scroll from "../Header/Scroll";
import Container from "../../common/Container";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Banner from "./components/Banner";
import Intro from "./components/Intro";
import Image from "../../assets/images/cage.jpg";
import CoreValues from "./components/CoreValues";
import Impact from "./components/Impact";
// import OurMission from "./components/OurMission";
// import BlueEconomy from "./components/BlueEconomy";
import image2 from "../../assets/images/stream.jpg";
import image3 from "../../assets/images/core.jpg";
import Team from "./components/Team";
import Pathway from "./components/Pathway";
// import Focus from "./components/Focus";
import Vision from "./components/Vision";
import Pillars from "./components/Pillars";
import HowWeWork from "./components/HowWeWork";

const styles = {
  paperContainer: {
    height: 300,
    backgroundImage: `url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const styles2 = {
  paperContainer: {
    height: 900,
    backgroundImage: `url(${image2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    objectFit: "cover",
  },
};

const styles3 = {
  paperContainer: {
    height: 800,
    backgroundImage: `url(${image3})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    objectFit: "cover",
  },
};

const About = () => {
  const theme = useTheme();
  return (
    <Box>
      <Helmet>
        <title> About Us | Blue Echo Foundation</title>
      </Helmet>
      <Scroll>
        <AppBar
          position={"sticky"}
          elevation={0}
          sx={{
            backgroundColor: theme.palette.background.paper,
            padding: "10px 0px",
          }}
        >
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box style={styles.paperContainer}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box>
        <Container>
          <Intro />
        </Container>
      </Box>
      <Box>
        <Container>
          <Vision />
        </Container>
      </Box>
      <Box>
        <Container>
          <Pillars />
        </Container>
      </Box>
      <Box bgcolor={"#fff"}>
        <HowWeWork />
      </Box>
      <Box display={{ xs: "none", sm: "inline" }}>
        <Pathway />
      </Box>
      <Box style={styles3.paperContainer} display={{ xs: "block", sm: "none" }}>
        <Pathway />
      </Box>
      <Box>
        <Container>
          <CoreValues />
        </Container>
      </Box>
      <Box display={{ xs: "none", sm: "inline" }}>
        <Impact />
      </Box>
      <Box style={styles2.paperContainer} display={{ xs: "block", sm: "none" }}>
        <Impact />
      </Box>
      <Box>
        <Container>
          <Team />
        </Container>
      </Box>
      {/* <Box>
        <Container>
          <BlueEconomy />
        </Container>
      </Box> */}
      <Box bgcolor={"#fff"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default About;
